import { render } from "./product_details.vue?vue&type=template&id=377056ea"
import script from "./product_details.vue?vue&type=script&lang=js"
export * from "./product_details.vue?vue&type=script&lang=js"

import exportComponent from "/home/raphael/git/proclima/retailerportal/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__